import Inputmask from 'inputmask';

export default () =>
  Inputmask('(999) 999-9999 x9[9[9[9]]]', {
    onBeforeMask: (phone: string) => phone.replace(/\D/g, ''),
    showMaskOnHover: false,
    showMaskOnFocus: false,
    inputmode: 'tel',
  });
